import { connect } from 'react-redux';
import api from '../../../utils/api';

import DeviceGuidelinesView from '../components/DeviceGuidelinesView';

const mapActionCreators = dispatch => ({
    getGuidelines: payload => dispatch(api.actions.device_guidelines.get()),
    updateGuidelines: payload => dispatch(api.actions.device_guidelines.update(payload)),
});

const mapStateToProps = state => ({
    device_guidelines: state.device_guidelines.get('settings'),
});

export default connect(
    mapStateToProps,
    mapActionCreators
)(DeviceGuidelinesView);
